// extracted by mini-css-extract-plugin
export default {"btn":"DownloadButton_btn__MF34O","spinner":"DownloadButton_spinner__ZdA0A"};